<template>
    <side-container v-on="$listeners"
        v-bind="$attrs"
        v-if="visible"
        :width="570"
        :headerTitle="'导入详情'"
        :isShowFooter="false"
        :isShowFooterBtn="false"
        :isLoading="isLoading"
        @close="$emit('update:visible', false)">
        <el-table ref="elTable"
            :data="tableData"
            :height="'100%'"
            :empty-text="isLoading ? ' ' : '暂无数据'">
            <el-table-column
                label="时间"
                prop="create_time"
                width="110">
                <template v-slot="{ row }">
                    <template v-if="row.create_time">
                        <p>{{ row.create_time.split(' ')[0] }}</p>
                        <p>{{ row.create_time.split(' ')[1] }}</p>
                    </template>
                    <p v-else>-</p>
                </template>
            </el-table-column>
            <el-table-column
                label="操作人"
                prop="operator"
                min-width="145">
                <template v-slot="{ row }">
                    <user-info :userInfo="get(row, 'creator.user') || {}" />
                </template>
            </el-table-column>
            <el-table-column
                label="导入会员 (位)"
                prop="members_imported"
                min-width="110">
            </el-table-column>
            <el-table-column
                label="导入方式"
                prop="prop"
                min-width="120">
                <template v-slot="{ row }">
                    <p class="text-popper" v-textPopper>{{ row.ls_shop_id ? '老零售店铺导入' : '表格导入' }}</p>
                </template>
            </el-table-column>
            <el-table-column
                label="操作"
                prop="prop"
                min-width="50">
                <template v-slot="{ row }">
                    <router-link class="href"
                        :to="{
                            name: 'memberImportOperateDetail',
                            params: {
                                from: $route.path
                            },
                            query: {
                                recordId: row.id
                            }
                        }">详情</router-link>
                </template>
            </el-table-column>
            <p v-if="isHasMore && isScrollLoading" slot="append" style="text-align: center; padding: 10px;">
                <span class="loading-step-animation">正在加载...</span>
            </p>
            <p v-if="(!isHasMore) && tableData.length > 0" slot="append" style="text-align: center; padding: 10px;">没有更多了</p>
        </el-table>
    </side-container>
</template>

<script lang="ts">
import { createComponent, ref, watch, onBeforeMount, onMounted } from '@vue/composition-api'
import SideContainer from '@/components/layout/side-container-style2.vue'
import { openMessage, useScrollLoad } from '../../../../utils/system'
import $fetch from '../../../../api'
import get from 'lodash/get'
import clone from 'lodash/cloneDeep'

interface IImportRecordParams {
    page: number
    limit: number
}

export default createComponent({
    props: {
        visible: Boolean
    },

    setup: (props, ctx) => {
        const isLoading = ref(false)
        const tableData = ref<any[]>([])

        const {
            page: oPage,
            isHasMore,
            isLoading: isScrollLoading,
            bindListener,
            initScrollLoad
        } = useScrollLoad()

        watch(() => props.visible, (newVal) => {
            if (newVal) {
                bindListener({
                    dom: (ctx.refs.elTable as any).$el.querySelector('.el-table__body-wrapper'),
                    loadFunction: getImportRecord
                })
                initData()
                isLoading.value = true
                getImportRecord()
                    .then(() => isLoading.value = false)
            }
        })

        async function getImportRecord(page = oPage.value, limit = 20) {
            try {
                const params: IImportRecordParams = {
                    page,
                    limit
                }
                const result = await $fetch.post({
                    url: '/membership/migration/getlsmemberimportrecords',
                    params
                })
                console.log('导入记录', clone(result))
                if (page === 1) {
                    tableData.value = result.records
                    initScrollLoad(result)
                } else {
                    tableData.value = tableData.value.concat(result.records)
                }
                return result
            } catch (e) {
                openMessage('error', e.message || '获取导入记录失败')
            }
        }

        function initData() {
            isLoading.value = false
            isScrollLoading.value = false
            isHasMore.value = true
            oPage.value = 1
            tableData.value = []
        }

        return {
            isLoading,
            isScrollLoading,
            isHasMore,
            tableData,
            get
        }
    },

    components: {
        SideContainer
    }
})
</script>

<style lang="scss" scoped>
::v-deep .container main {
    padding: 20px 13px;
}

::v-deep .el-table {
    margin-top: 0 !important;

    .el-table__body-wrapper {
        overflow-x: hidden;
    }
}
</style>
